import { action, observable, makeObservable } from 'mobx';
import { State, closed, open } from './Types';

class ModalStore {
  @observable
  state: State = closed();

  constructor() {
    makeObservable(this);
  }

  @action
  close = () => {
    this.state = closed();
  };

  @action
  open = () => {
    this.state = open();
  };
}

export default ModalStore;
